import {
    Container,
    Box,
} from '@mui/material';
import { Link } from './general';

const PageNotFound = () => {
    return (
        <Container sx={{
            minHeight: '550px', 
            display: 'flex', 
            justifyContent: 'center',
            alignItems: 'center',
        }}>
            <Box sx={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                fontSize: '36px', 
                flexDirection: 'column' 
            }}>
                <Box>
                    Page is not found &#129488;
                </Box>
                <Box sx={{fontSize: '24px', mt: 2}}>
                    Return to <Link href='/' target={null}>main</Link>
                </Box>
            </Box>
        </Container>
    );
}

export default PageNotFound;